import { render, staticRenderFns } from "./ABMVouchers.vue?vue&type=template&id=53defc0c"
import script from "./ABMVouchers.vue?vue&type=script&lang=js"
export * from "./ABMVouchers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports